/**
 * Tests for ConfirmDeleteDialog component.
 *
 * Verifies rendering, button states, and callback invocations.
 */

import React from "react";
import { render, screen, fireEvent } from "@testing-library/react";
import "@testing-library/jest-dom";
import ConfirmDeleteDialog from "./ConfirmDeleteDialog";

describe("ConfirmDeleteDialog", () => {
  const defaultProps = {
    open: true,
    onClose: jest.fn(),
    onConfirm: jest.fn(),
    isDeleting: false,
  };

  beforeEach(() => {
    jest.clearAllMocks();
  });

  describe("Rendering", () => {
    it("renders dialog title and warning message", () => {
      render(<ConfirmDeleteDialog {...defaultProps} />);
      expect(screen.getByText("Confirm Delete")).toBeInTheDocument();
      expect(
        screen.getByText(/are you sure you want to delete this record/i),
      ).toBeInTheDocument();
    });

    it("renders Delete and Cancel buttons", () => {
      render(<ConfirmDeleteDialog {...defaultProps} />);
      expect(
        screen.getByRole("button", { name: /delete/i }),
      ).toBeInTheDocument();
      expect(
        screen.getByRole("button", { name: /cancel/i }),
      ).toBeInTheDocument();
    });

    it("does not render content when closed", () => {
      render(<ConfirmDeleteDialog {...defaultProps} open={false} />);
      expect(screen.queryByText("Confirm Delete")).not.toBeInTheDocument();
    });
  });

  describe("Button Actions", () => {
    it("calls onConfirm when Delete is clicked", () => {
      render(<ConfirmDeleteDialog {...defaultProps} />);
      fireEvent.click(screen.getByRole("button", { name: /delete/i }));
      expect(defaultProps.onConfirm).toHaveBeenCalledTimes(1);
    });

    it("calls onClose when Cancel is clicked", () => {
      render(<ConfirmDeleteDialog {...defaultProps} />);
      fireEvent.click(screen.getByRole("button", { name: /cancel/i }));
      expect(defaultProps.onClose).toHaveBeenCalledTimes(1);
    });
  });

  describe("Deleting State", () => {
    it("disables Cancel button while deleting", () => {
      render(<ConfirmDeleteDialog {...defaultProps} isDeleting={true} />);
      expect(screen.getByRole("button", { name: /cancel/i })).toBeDisabled();
    });
  });
});
